import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/captura/captura-client.tsx");
